import React from 'react'
import { SponsorBadge as SponsorBadgeComponent } from '@digitalmedia/sn-design-system'
import useAds from 'context/AdsContext'

import { getParameterByName } from 'utils/js/browser_helpers'

function SponsorBadge({ targetMode }) {
    const { adTargets, siteTargetings } = useAds()
    const testValue = getParameterByName('adutil_test')
    const forceTestBadge = getParameterByName('force_test_badge')

    if (forceTestBadge)
        return <div style={{ height: 50, width: 150, backgroundColor: 'red' }}></div>

    return (
        <div>
            <SponsorBadgeComponent
                id="sn-badge"
                adTargets={{
                    ...adTargets,
                    ...(testValue && { test_ops: testValue }),
                }}
                siteTargeting={siteTargetings}
                adUnitPath={adTargets.ad_unit_path}
                targetMode={targetMode}
                currentUrl={window.href}
            />
        </div>
    )
}

export default React.memo(SponsorBadge)
